import { useApp } from "../app/AppContext";
import type { Project, Task } from "../lib/api";
import { hourLabel, todayKey } from "../lib/date";
import { isHardLate, priColor } from "../lib/tasks";

export function TaskMeta({
  task,
  projects,
}: {
  task: Task;
  projects: Map<string, Project>;
}) {
  const p = task.projectId ? projects.get(task.projectId) : undefined;
  const late = isHardLate(task);
  return (
    <div className="tm">
      <span
        className="pri"
        style={{ background: priColor(task.pri), color: priColor(task.pri) }}
      />
      {p && (
        <span className="tag" style={{ background: `${p.color}22`, color: p.color }}>
          {p.name}
        </span>
      )}
      {task.energy === "high" && (
        <span className="tag" style={{ background: "#B78CFF22", color: "#B78CFF" }}>
          ⚡deep
        </span>
      )}
      {task.estMin != null && <span className="est">{task.estMin}m</span>}
      {task.deadline && (
        <span className={`ddl${late ? " late" : ""}`}>⚑{task.deadline.slice(5)}</span>
      )}
      {task.fromHour != null && task.doDate === todayKey() && (
        <span className="est" style={{ color: "var(--accent)" }}>
          {hourLabel(task.fromHour)}
        </span>
      )}
    </div>
  );
}

export function TaskRow({
  task,
  projects,
  onToggle,
  onStar,
  onDelete,
  draggable = false,
}: {
  task: Task;
  projects: Map<string, Project>;
  onToggle: (t: Task) => void;
  onStar: (t: Task) => void;
  onDelete: (t: Task) => void;
  draggable?: boolean;
}) {
  const app = useApp();
  return (
    <div
      className={`trow${task.status === "done" ? " done" : ""}${
        isHardLate(task) ? " hardlate" : ""
      }${draggable ? " drag" : ""}`}
      draggable={draggable}
      onDragStart={(e) => e.dataTransfer.setData("text/plain", task.id)}
    >
      <button
        className={`chk${task.status === "done" ? " on" : ""}`}
        onClick={() => onToggle(task)}
        aria-label="Toggle done"
      />
      <div style={{ minWidth: 0, flex: 1 }}>
        <div className="tt" onClick={() => app.openTask(task.id)} title="Edit task">
          {task.title}
        </div>
        <TaskMeta task={task} projects={projects} />
      </div>
      <div className="rowact">
        <button
          className={`star${task.mit ? " on" : ""}`}
          onClick={() => onStar(task)}
          title="Top 3"
        >
          ★
        </button>
        <button
          className="iconmini dgr"
          onClick={() => onDelete(task)}
          title="Delete"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
